module.exports = __webpack_public_path__ + "static/media/heal_bot.bef146ad.png";